import React, { FC } from 'react';
import { SCUIContent } from '../../atomic/organisms';
export const Template: FC<any> = () => {
    return (
        <SCUIContent>
            <div>Template Ro Page</div>
        </SCUIContent>
    );
};
